// extracted by mini-css-extract-plugin
export default {"base":"X_Tk4","breadcrumbs":"R80pG","heading":"bFiR6","text":"tljpO","notFound":"bfM2t"};